import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../LanguageContext';

import ArtworkDataService from '../../services/ArtworkService';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import DateFilter from '../../components/Filters/DateFilter';
import NameFilter from '../../components/Filters/NameFilter';
import FreeSearchFilter from '../../components/Filters/FreeSearchFilter';
import CategoriesFilter from '../../components/Filters/CategoriesFilter';
import SubjectFilter from '../../components/Filters/SubjectFilter';
import LuogoConservazioneFilter from '../../components/Filters/LuogoConservazioneFilter';

import ArtworkList from '../../components/Artwork/ArtworkList';
import ArtworkDetails from '../../components/Artwork/ArtworkDetails';
import ErrorLoading from '../../components/Error/Error';
import PaginationComponent from '../../components/Artwork/PaginationComponent';
import './Artworklistpage.scss';

const ArtworksList = () => {
  const [artworks, setArtworks] = useState([]);
  const [currentArtwork, setCurrentArtwork] = useState(null);
  const [error, setError] = useState(false);
  const [detailError, setDetailError] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(-1);
  const [searchName, setSearchName] = useState('');
  
  const [searchData_inizio, setSearchData_inizio] = useState('');
  const [searchData_fine, setSearchData_fine] = useState('');

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(15);
  const [totalArtworksCount, setTotalArtworksCount] = useState(0);
  const [loading, setLoading] = useState(false);

  const [tags, setTags] = useState([]);
  const [selectedTag, setSelectedTag] = useState('');

  const [subjectTags, setSubjectTags] = useState([]);
  const [selectedSubjectTag, setSelectedSubjectTag] = useState('');

  const [search_luogo_conservazione, setSearch_luogo_conservazione] = useState('');
  const [freeSearch, setFreeSearch] = useState('');

  // Ricerca semantica in linguaggio naturale (Fase 2: RAG con pgvector)
  const [semQuery, setSemQuery] = useState('');
  const [semActive, setSemActive] = useState(false);
  // filtri avanzati ripiegati ovunque: la ricerca e' la pagina
  const [filtersOpen, setFiltersOpen] = useState(false);

  const { selectedLanguage } = useLanguage();

  const onChangeSelectedTag = (e) => {
    const selectedTag = e.target.value;
    setSelectedTag(selectedTag);
  };

  const onChangeSelectedSubjectTag = (e) => {
    const selectedSubjectTag = e.target.value;
    setSelectedSubjectTag(selectedSubjectTag);
  };

  const onChangeSearchName = (e) => {
    const searchName = e.target.value;
    setSearchName(searchName);
  };

  const onChangeLuogoConservazione = (e) => {
    const luogo_conservazione = e.target.value;
    setSearch_luogo_conservazione(luogo_conservazione);
  };

  const onChangeSearchDataInizio = (e) => {
    const searchData_inizio = e.target.value;
    setSearchData_inizio(searchData_inizio);
  };

  const onChangeSearchDataFine = (e) => {
    const searchData_fine = e.target.value;
    setSearchData_fine(searchData_fine);
  };

  const onChangeFreeSearch = (e) => {
    const searchFree = e.target.value;
    setFreeSearch(searchFree);
  };

  const retrieveTags = () => {
    ArtworkDataService.getTagsSWR((freshData) => {
      setTags(freshData.response || []);
    })
      .then((response) => {
        setTags(response.response || []);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const retrieveSubjectTags = () => {
    ArtworkDataService.getSubjectTagsSWR((freshData) => {
      setSubjectTags(freshData.response || []);
    })
      .then((response) => {
        setSubjectTags(response.response || []);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const retrieveArtworks = (page = 1, ov = {}) => {
    setLoading(true);
    setError(false);
    setCurrentPage(page);
    const v = (key, cur) => (ov[key] !== undefined ? ov[key] : cur);
    ArtworkDataService.getAllSWR(page, pageSize, v('searchName', searchName), v('data_inizio', searchData_inizio), v('data_fine', searchData_fine), v('selectedTag', selectedTag), v('selectedSubjectTag', selectedSubjectTag), v('luogo', search_luogo_conservazione), selectedLanguage, v('freeSearch', freeSearch), (freshData) => {
        setArtworks(freshData.artworks);
        setTotalArtworksCount(freshData.totalArtworksCount);
        setLoading(false);
      })
      .then((response) => {
        setArtworks(response.artworks);
        setTotalArtworksCount(response.totalArtworksCount);
      })
      .catch((e) => {
        console.error(e);
        setError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handlePageChange = (page, pageSize, searchName, searchData_inizio, searchData_fine, selectedTag, selectedSubjectTag, search_luogo_conservazione, selectedLanguage, freeSearch) => {
    retrieveArtworks(page, pageSize, searchName, searchData_inizio, searchData_fine, selectedTag, selectedSubjectTag, search_luogo_conservazione, selectedLanguage, freeSearch);
  };

  useEffect(() => {
    retrieveTags();
    retrieveSubjectTags();
  }, []);

  useEffect(() => {
    retrieveArtworks(currentPage, pageSize, searchName, searchData_inizio, searchData_fine, selectedTag, selectedSubjectTag, search_luogo_conservazione, selectedLanguage, freeSearch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, pageSize]);

  const runSemanticSearch = () => {
    if (!semQuery.trim()) return;
    setLoading(true);
    setError(false);
    setCurrentArtwork(null);
    ArtworkDataService.semanticSearch(semQuery.trim(), selectedLanguage)
      .then((response) => {
        setArtworks(response.artworks);
        setTotalArtworksCount(response.artworks.length);
        setSemActive(true);
      })
      .catch((e) => {
        console.error(e);
        setError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const clearSemanticSearch = () => {
    setSemActive(false);
    setSemQuery('');
    retrieveArtworks(1);
  };

  const resetFilters = () => {
    setSearchName('');
    setSearchData_inizio('');
    setSearchData_fine('');
    setSelectedTag('');
    setSelectedSubjectTag('');
    setSearch_luogo_conservazione('');
    setFreeSearch('');
    setSemActive(false);
    setSemQuery('');
    retrieveArtworks(1, { searchName: '', data_inizio: '', data_fine: '',
      selectedTag: '', selectedSubjectTag: '', luogo: '', freeSearch: '' });
  };

  // scoperta casuale: apre un'opera a caso tra i risultati correnti
  const surpriseMe = () => {
    if (!artworks || artworks.length === 0) return;
    const index = Math.floor(Math.random() * artworks.length);
    setActiveArtwork(artworks[index], index);
  };

  const setActiveArtwork = (artwork, index) => {
    setCurrentIndex(index);
    setCurrentArtwork(null);
    setDetailError(false);
    ArtworkDataService.get(artwork.id)
      .then((response) => {
        setCurrentArtwork(response.response);
      })
      .catch((e) => {
        console.error(e);
        setDetailError(true);
      });
  };

  const closeDetail = () => {
    setCurrentArtwork(null);
    setDetailError(false);
    setCurrentIndex(-1);
  };

  // Esc chiude il drawer del dettaglio
  useEffect(() => {
    const onKeyDown = (e) => { if (e.key === 'Escape') closeDetail(); };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container className='bg-container'>
      <br />
      <div className="semanticSearchBox">
        <label className="semanticLabel" htmlFor="semanticInput">
          ✨ {selectedLanguage === 'it' ? 'Chiedi al catalogo' : 'Ask the catalogue'}
          <span className="betaBadge">beta</span>
        </label>
        <div className="input-group">
          <input
            id="semanticInput"
            type="text"
            className="form-control"
            placeholder={selectedLanguage === 'it'
              ? 'es. cofanetti in avorio del X secolo conservati a Venezia'
              : 'e.g. ivory caskets of the 10th century kept in Venice'}
            value={semQuery}
            onChange={(e) => setSemQuery(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') runSemanticSearch(); }}
          />
          <div className="input-group-append">
            <button
              className="btn semanticBtn"
              type="button"
              onClick={runSemanticSearch}
              disabled={loading || !semQuery.trim()}
            >
              {loading && semQuery.trim()
                ? (selectedLanguage === 'it' ? 'Cerco…' : 'Searching…')
                : (selectedLanguage === 'it' ? 'Cerca' : 'Search')}
            </button>
          </div>
        </div>
        <div className="semanticFootRow">
        <button
          type="button"
          className="surpriseLink"
          onClick={surpriseMe}
        >
          ✨ {selectedLanguage === 'it' ? 'Sorprendimi: un\u2019opera a caso' : 'Surprise me: a random work'}
        </button>
        {semActive && (
          <span className="semanticNotice">
            {selectedLanguage === 'it'
              ? 'Risultati per pertinenza semantica'
              : 'Results by semantic relevance'}
            <button type="button" onClick={clearSemanticSearch}>
              {selectedLanguage === 'it' ? '✕ torna alla ricerca classica' : '✕ back to classic search'}
            </button>
          </span>
        )}
        </div>
      </div>
      {/* faccetta tempo: la firma del catalogo, sempre visibile */}
      <DateFilter
        searchData_fine={searchData_fine}
        searchData_inizio={searchData_inizio}
        onChangeSearchDataInizio={onChangeSearchDataInizio}
        onChangeSearchDataFine={onChangeSearchDataFine}
        retrieveArtworks={retrieveArtworks}
      />

      {/* tutto il resto raffina: filtri avanzati ripiegati ovunque */}
      <button
        type="button"
        className={`advancedToggle ${filtersOpen ? 'open' : ''}`}
        aria-expanded={filtersOpen}
        onClick={() => setFiltersOpen((o) => !o)}
      >
        ⚙ {selectedLanguage === 'it' ? 'Filtri avanzati' : 'Advanced filters'} <span className="chev">▸</span>
      </button>
      {filtersOpen && (
        <div className="research-advanced mb-2">
          <Row>
            <Col md={4}>
              <NameFilter searchName={searchName} onChangeSearchName={onChangeSearchName} retrieveArtworks={retrieveArtworks} />
            </Col>
            <Col md={4}>
              <FreeSearchFilter freeSearch={freeSearch} onChangeFreeSearch={onChangeFreeSearch} retrieveArtworks={retrieveArtworks} />
            </Col>
            <Col md={4}>
              <CategoriesFilter tags={tags} selectedTag={selectedTag} retrieveArtworks={retrieveArtworks} onChangeSelectedTag={onChangeSelectedTag} />
            </Col>
            <Col md={4}>
              <SubjectFilter subjectTags={subjectTags} selectedSubjectTag={selectedSubjectTag} retrieveArtworks={retrieveArtworks} onChangeSelectedSubjectTag={onChangeSelectedSubjectTag} />
            </Col>
            <Col md={4}>
              <LuogoConservazioneFilter search_luogo_conservazione={search_luogo_conservazione} onChangeLuogoConservazione={onChangeLuogoConservazione} retrieveArtworks={retrieveArtworks} />
            </Col>
            <Col md={4}>
              <button className="btn btn-outline-secondary" type="button" onClick={resetFilters}>
                {selectedLanguage === 'it' ? 'Azzera filtri' : 'Reset filters'}
              </button>
            </Col>
          </Row>
        </div>
      )}

      {/* conteggio: riduce l'incertezza dello studioso */}
      <div className="research-count">
        {totalArtworksCount} {selectedLanguage === 'it'
          ? (totalArtworksCount === 1 ? 'opera' : 'opere')
          : (totalArtworksCount === 1 ? 'work' : 'works')}
        {' · '}
        {semActive
          ? (selectedLanguage === 'it' ? 'per pertinenza semantica' : 'by semantic relevance')
          : (selectedLanguage === 'it' ? 'in ordine cronologico' : 'in chronological order')}
      </div>

      {/* griglia risultati image-first, tutta larghezza */}
      {error ? (
        <div className="text-center">
          <ErrorLoading />
          <button className="btn btn-outline-secondary mt-2"
                  onClick={() => retrieveArtworks(currentPage)}>
            {selectedLanguage === 'it' ? 'Riprova' : 'Retry'}
          </button>
        </div>
      ) : (
        <ArtworkList
          artworks={artworks}
          currentIndex={currentIndex}
          setCurrentArtwork={setCurrentArtwork}
          setActiveArtwork={setActiveArtwork}
          setCurrentIndex={setCurrentIndex}
          loading={loading}
        />
      )}
      {totalArtworksCount > pageSize && (
        <PaginationComponent
          currentPage={currentPage}
          pageSize={pageSize}
          totalArtworksCount={totalArtworksCount}
          handlePageChange={handlePageChange}
        />
      )}

      {/* dettaglio: drawer laterale persistente (la griglia resta visibile) */}
      {(currentArtwork || detailError) && (
        <div className="drawerBackdrop" onClick={closeDetail} aria-hidden="true" />
      )}
      <div className={`text-left boxDetails ${currentArtwork || detailError ? 'hasDetail' : ''}`}>
        <button
          type="button"
          className="detailCloseBtn"
          onClick={closeDetail}
        >
          ✕ {selectedLanguage === 'it' ? 'Chiudi' : 'Close'}
        </button>
        {detailError ? (
          <ErrorLoading />
        ) : currentArtwork ? (
          <ArtworkDetails currentArtwork={currentArtwork} />
        ) : null}
      </div>
    </Container>
  );
};

export default ArtworksList;
